import { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { isMobile, withOrientationChange } from 'react-device-detect';
import { withRouter } from 'react-router-dom';
import PricingPlansCard from './PricingPlansCard';
import withComponentName from '../../../../../decorators/withComponentName';

import { PricingCards, headerCells, tableContent } from '../../../../../data/realTimeApi';

import Styles from './style.module.scss';
import PricingPlansFilter from './PricingPlansFilter';
import PricingPlansColumnLayout from './PricingPlansColumnLayout';
import DcscPoweredByWithTooltip from '../../../../Shared/DcscPoweredByWithTooltip';

const cx = classNames.bind(Styles);

export class PricingPlans extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeShowType: 'Quarterly',
      activePlanTab: 'commercial',
      activeLayoutTab: isMobile ? 'detailed' : 'column',
    };
    this.handlePlanChange = this.handlePlanChange.bind(this);
    this.handleLayoutChange = this.handleLayoutChange.bind(this);
  }

  componentDidMount() {
    const { isPortrait } = this.props;
    const { history } = this.props;
    const activePlan = history.location.pathname.split('/').reverse()[0];
    this.setState({
      activePlanTab: activePlan,
    });
    if (isMobile && isPortrait) {
      this.setState({
        activeLayoutTab: 'detailed',
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPortrait } = this.props;

    const { history, width, promobarHeight } = this.props;
    const activePlan = history.location.pathname.split('/').reverse()[0];
    if (prevState.activePlanTab !== activePlan) {
      this.setState({
        activePlanTab: activePlan,
      });
      if (width > 767) {
        const pageScroll = document.getElementById('commercial').offsetTop;
        window.scrollTo({
          top: pageScroll - 90 - promobarHeight,
          behavior: 'smooth',
        });
      }
    }
    if (prevProps.isPortrait !== isPortrait) {
      if (isMobile && isPortrait) {
        this.setState({
          activeLayoutTab: 'detailed',
        });
      }
    }
  }

  handlePlanChange = (id) => {
    const { history } = this.props;
    this.setState({
      activePlanTab: id,
    }, () => {
      const { activePlanTab } = this.state;
      history.replace(`/products/api/financial-news/pricing-api/${activePlanTab}`);
    });
  };

  handleLayoutChange = (id) => {
    this.setState({
      activeLayoutTab: id,
    });
  };

  scrollToForm(e) {
    e.preventDefault();

    document.querySelector('#contactus-form').scrollIntoView({
      behavior: 'smooth',
    });
  }

  render() {
    const { activeShowType, activeLayoutTab, activePlanTab } = this.state;

    return (
      <div className={cx('PricingPlans')}>
        <div className={cx('PricingPlans__filter', { column: activeLayoutTab === 'column' })}>
          <PricingPlansFilter
            handleLayoutChange={this.handleLayoutChange}
            handlePlanChange={this.handlePlanChange}
            activeLayoutTab={activeLayoutTab}
            activePlanTab={activePlanTab}
          />
        </div>

        <div className={cx('PricingPlans__note')}>
          Taxes will be added where applicable. All prices are in United States Dollars.
        </div>

        <div className={cx('PricingPlans__content')}>
          {activeLayoutTab === 'detailed'
            ? PricingCards.filter((item) => item.planType === activePlanTab).map(({
              logo, header, content, contentMobile,
            }, index) => (

              <PricingPlansCard
                index={index}
                key={header.title}
                logo={logo}
                header={header}
                content={content}
                contentMobile={contentMobile}
                priceType={activeShowType}
                activePlanTab={activePlanTab}
              />

            )) : (
              <PricingPlansColumnLayout
                activePlanTab={activePlanTab}
                headerCells={headerCells}
                content={tableContent}
              />
            )}
        </div>

        <div className={cx('PricingPlans__footer', { [`${activePlanTab}`]: true })} id="table-hint">
          <p>
            Students, professors, educational institutions,
            {' '}
            and non-profit organisations receive up to 50% off.
            <button
              type="button"
              onClick={this.scrollToForm}
            >
              Request your discount
            </button>
          </p>
          <p>
            Need company relevance scores, multi-interconnected
            sector hierarchies, and smart portfolios? Try
            <DcscPoweredByWithTooltip className={Styles.dcsc} />
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ common, promobar }) => ({
  width: common.width,
  promobarHeight: promobar.height,
});

export default connect(mapStateToProps)(
  withComponentName(withRouter(withOrientationChange(PricingPlans))),
);
